import React from 'react';
import InputPhone from '~c/ui/InputPhone';
import Input from './Input';
import InputAddress from '~c/ui/InputAddress';
import InputUfms from '~c/ui/InputUfms';
import InputCompany from '~c/ui/InputCompany';
import InputBank from '~c/ui/InputBank';
import InputCity from '~c/ui/InputCity';

const defaultPrepareInputProps = {
  onChangeCallback: () => {},
  onBlurCallback: () => {},
  type: 'text',
  error: false,
  classes: '',
  alwaysDisabled: false,
  validator: () => true,
};

/**
 *
 * @param {{
 *            name: string,
 *            value: *,
 *            label: string,
 *            onChangeCallback: function|undefined,
 *            type: "address"|"ufms"|"passport"|"date"|"phone"|"text"|null|undefined,
 *            classes: string[]|undefined,
 *            error: boolean|undefined,
 *          }} props - props
 *
 * @return {*} React Component
 */
export const prepareInput = props => {
  const preparedProps = { ...defaultPrepareInputProps, ...props };
  const {
    name,
    value,
    label,
    classes,
    onChangeCallback,
    type,
    error,
    isPending,
    disabled,
    alwaysDisabled,
    onBlurCallback,
  } = preparedProps;

  const isDisabled = disabled || alwaysDisabled;

  switch (type) {
    case 'address':
      return (
        <InputAddress
          key={name}
          error={error}
          disabled={isDisabled}
          className={!error ? `inp__field` : `inp__field inp__field--error`}
          labelClassName={['inp', classes].join(' ')}
          label={label}
          value={value}
          placeholder=" "
          onChange={val => onChangeCallback(name, val)}
          onBlur={e => onBlurCallback(name, e.target.value)}
        />
      );

    case 'ufms':
      return (
        <InputUfms
          key={name}
          error={error}
          disabled={isDisabled}
          className={!error ? `inp__field` : `inp__field inp__field--error`}
          labelClassName={['inp', classes].join(' ')}
          label={label}
          value={value}
          placeholder=" "
          onChange={val => onChangeCallback(name, val)}
          onBlur={e => onBlurCallback(name, e.target.value)}
        />
      );

    case 'passport':
      return (
        <Input
          key={name}
          disabled={isDisabled}
          className={classes}
          value={value}
          name={name}
          label={label}
          error={error}
          type={type}
          mask="9999 999999"
          onChange={val => onChangeCallback(name, val)}
          onBlur={val => onBlurCallback(name, val)}
        />
      );

    case 'date':
      return (
        <Input
          key={name}
          disabled={isDisabled}
          className={classes}
          value={value}
          name={name}
          label={label}
          error={error}
          type={type}
          onChange={val => onChangeCallback(name, val)}
          onBlur={val => onBlurCallback(name, val)}
        />
      );

    case 'phone':
      return (
        <InputPhone
          disabled={isDisabled}
          value={value}
          error={error}
          onChange={val => onChangeCallback(name, val)}
          onBlur={val => onBlurCallback(name, val)}
          key={name}
        >
          <p className="inp__label">{label}</p>
        </InputPhone>
      );

    case 'company':
      return (
        <InputCompany
          disabled={isDisabled}
          key={name}
          error={error}
          className={!error ? `inp__field` : `inp__field inp__field--error`}
          labelClassName={['inp', classes].join(' ')}
          label={label}
          value={value}
          placeholder=" "
          onChange={(val, dadata) => onChangeCallback(name, val, dadata)}
          onBlur={e => onBlurCallback(name, e.target.value)}
        />
      );

    case 'bank':
      return (
        <InputBank
          key={name}
          disabled={isDisabled}
          className={!error ? `inp__field` : `inp__field inp__field--error`}
          labelClassName={['inp', classes].join(' ')}
          label={label}
          value={value}
          placeholder=" "
          onChange={(val, dadata) => onChangeCallback(name, val, dadata)}
          onBlur={e => onBlurCallback(name, e.target.value)}
        />
      );

      case 'city':
      return (
        <InputCity
          key={name}
          error={error}
          disabled={isDisabled}
          className={!error ? `inp__field` : `inp__field inp__field--error`}
          labelClassName={['inp', classes].join(' ')}
          label={label}
          value={value}
          placeholder=" "
          onChange={(val, dadata) => onChangeCallback(name, val, dadata)}
          onBlur={e => onBlurCallback(name, e.target.value)}
        />
      );

    case 'paymentAccount':
      return (
        <Input
          key={name}
          disabled={isDisabled}
          className={classes}
          value={value}
          name={name}
          label={label}
          error={error}
          type={type}
          mask="99999999999999999999"
          onChange={val => onChangeCallback(name, val)}
          onBlur={val => onBlurCallback(name, val)}
        />
      );

    default:
      return (
        <Input
          key={name}
          disabled={isDisabled}
          value={value}
          name={name}
          label={label}
          error={error}
          type={type}
          isPending={isPending}
          onChange={val => onChangeCallback(name, val)}
          onBlur={val => onBlurCallback(name, val)}
        />
      );
  }
};

export const splitInputsByRenderBlock = inputs => {
  const objectFromInputs = {};
  inputs.forEach(input => {
    if (!objectFromInputs[input.renderBlock]) {
      objectFromInputs[input.renderBlock] = [input];
    } else {
      objectFromInputs[input.renderBlock].push(input);
    }
  });
  return Array.from(Object.values(objectFromInputs));
};

export const mergeInputs = (inputs, disabledInputs) => {
  const mergedInputs = inputs.map(input => {
    const newInput = { ...input };
    const disabledState = disabledInputs.find(
      disabledInput => disabledInput.name === newInput.name,
    )?.disabled;
    newInput.disabled = disabledState ?? newInput.disabled;
    return newInput;
  });
  return mergedInputs;
};